import mushroom from './mushroom.mailing';
import CauHinhApi from '../moduleApi/CauHinhApi';
import ProfileApi from '../moduleApi/ProfileApi';
import AccountApi from '../moduleApi/AccountApi';
import MethodService from './MethodService';
import { blockUi, unblockUi } from '../shared/utils';

window.requestCount = 0;

let MailingService = {};


//send email
MailingService.sendEmail = async(countPhanHois) => {
    try {
        let dataFilter = {
            filters: 'code:in:tcqltt_email'
        };
        let resConfig = await CauHinhApi.list(dataFilter);
        let emailAddress = "";
        if (resConfig.result) {
            emailAddress = resConfig.result[0].value;
        }
        let pathLocation = location.protocol + '//' + location.host + '/admin/home';

        let currentUser = await MethodService.getCurrentUser();
        let profile = await ProfileApi.findById(currentUser.id);
        let userNameSend = "";
        let userNameEmail = "";

        if (profile.result) {
            userNameSend = profile.result.ho_ten.ho_ten;
            userNameEmail = ' (Email: ' + profile.result.email + ')';
        }

        await mushroom.$mail.sendAsync({
            from: {
                name: "Biin Tourism",
                email: "vssdulich@gmail.com"
            },
            to: [{
                email: emailAddress
            }],
            subject: "Bạn vừa nhận được " + countPhanHois + " phản hồi của người dùng từ hệ thống Biin Tourism",
            content: 'Người gửi: ' + userNameSend + userNameEmail +
                '<br>Số lượng phản hồi cần phê duyệt mới: ' + countPhanHois +
                '<br/>Bạn hãy đăng nhập vào đường link sau để phê duyệt: ' +
                '<a target="_blank" href ="' + pathLocation + '">' + pathLocation + '</a>',
            isHtml: true
        });
        toastr.success("Gửi phản hồi thành công");
        return 1;
    } catch (ex) {
        console.log("Có lỗi:", ex.message);
        toastr.error("Gửi phản hồi thất bại");
        return 0;
    } finally {
        // console.log('End');
    }

};

//send email TCQLTT
MailingService.sendEmailTcqltt = async(nguoi_gui_id, nguoi_nhan_id) => {
    try {

        let pathLocation = location.protocol + '//' + location.host + '/admin/home';

        let profile = await ProfileApi.findById(nguoi_gui_id);
        let userNameSend = "";
        let userNameEmail = "";
        if (profile.result) {
            userNameSend = profile.result.ho_ten.ho_ten;
            userNameEmail = ' (Email: ' + profile.result.email + ')';
        }


        let profileNhan = await ProfileApi.findById(nguoi_nhan_id);
        let userNameRev = "";
        let userEmailRev = "";
        if (profileNhan.result) {
            userNameRev = profileNhan.result.ho_ten.ho_ten;
            userEmailRev = profileNhan.result.email;
        }
        // debugger;
        if (userEmailRev) {
            await mushroom.$mail.sendAsync({
                from: {
                    name: "Biin Tourism",
                    email: "vssdulich@gmail.com"
                },
                to: [{
                    email: userEmailRev
                }],
                subject: "Bạn vừa nhận được yêu cầu giải quyết phản hồi của người dùng từ hệ thống Biin Tourism",
                content: 'Người gửi: ' + userNameSend + userNameEmail +
                    '<br/>Bạn hãy đăng nhập vào đường link sau để phê duyệt: ' +
                    '<a target="_blank" href="' + pathLocation + '">' + pathLocation + '</a>',
                isHtml: true
            });
            toastr.success("Gửi thông báo xử lý phản hồi thành công");
            return 1;
        } else {
            toastr.warning("Người nhận không có email");
            return 0;
        }

    } catch (ex) {
        console.log("Có lỗi:", ex.message);
        toastr.error("Gửi thông báo xử lý phản hồi thất bại");
        return 0;
    } finally {
        // console.log('End');
    }

};

export default MailingService;